import React, { useEffect, useState } from "react";
import {
  IgniteMainWrapper,
  BannerSection,
  BannerContent,
  BannerTitle,
  BannerSubTitle,
  TeamWrapper,
  TeamCard,
  TeamGrid,
  TeamHeader,
  TeamImage,
  TeamImageWrapper,
  TeamInfoBox,
  TeamName,
  TeamRole,
  TeamSubtitle,
  TeamTitle,
  CoreTeamCard,
  CoreTeamGrid,
  CoreTeamHeader,
  CoreTeamSubtitle,
  CoreTeamTitle,
  CoreTeamWrapper,
  AvatarImage,
  AvatarRing,
  MemberName,
  MemberRole,
} from "./teamContent.styles";
import coreTeamData from "./CoreTeam.json";
import "./TeamContent.css";
import AOS from "aos";
import "aos/dist/aos.css";

function TestimonialsContent() {
  useEffect(() => {
    const handleAOS = () => {
      if (window.innerWidth > 768) {
        AOS.init({ duration: 800 });
      } else {
        AOS.refreshHard();
        document.querySelectorAll("[data-aos]").forEach((el) => {
          el.removeAttribute("data-aos");
        });
      }
    };
    handleAOS();
    window.addEventListener("resize", handleAOS);
    return () => window.removeEventListener("resize", handleAOS);
  }, []);
  return (
    <>
      <div className="few-pages-banner-wrap">
        <img
          src={process.env.PUBLIC_URL + "/Assets/AllBanners/team-banner-latest.png"}
          alt="Ignite banner"
          className="banner-img"
        />
        <div className="few-pages-banner-box">
          <div className="few-pages-banner-content">
            <h1 className="banner-main-head">Meet the Ignite Team</h1>
            <p className="banner-sub-text">
              The Ignite core team brings together diverse expertise to shape,
              build, and deliver the Ignite experience from concept to impact.
            </p>
          </div>
        </div>
      </div>

      <div className="team-meet-section">
        <h2 className="section-headings">Meet our Leaders</h2>
        <p className="section-sub-text">
          Ignite is guided by leaders with experience across technology,
          business, learning and capability building. They help shape direction,
          set priorities, and ensure learning remains aligned to real capability
          and business needs.
        </p>
      </div>

      <TeamWrapper>
        <TeamGrid className="all-team-mobile-box">
          <TeamCard data-aos="zoom-in">
            <TeamImageWrapper>
              <TeamImage
                src={`${process.env.PUBLIC_URL}/Assets/Team/Leader1.png`}
                alt="Shridhar Rajgopalan"
              />
            </TeamImageWrapper>

            <TeamInfoBox>
              <TeamName>Shridhar Rajgopalan</TeamName>
              <TeamRole>Ignite Program Sponsor</TeamRole>
            </TeamInfoBox>
          </TeamCard>

          <TeamCard data-aos="zoom-in">
            <TeamImageWrapper>
              <TeamImage
                src={`${process.env.PUBLIC_URL}/Assets/Team/Leader2.png`}
                alt="Saurabh Kaushik"
              />
            </TeamImageWrapper>

            <TeamInfoBox>
              <TeamName>Saurabh Kaushik</TeamName>
              <TeamRole>Ignite Program Lead</TeamRole>
            </TeamInfoBox>
          </TeamCard>
        </TeamGrid>

        {/* <CoreTeamWrapper>
          <CoreTeamHeader>
            <CoreTeamTitle>Core Team</CoreTeamTitle>
            <CoreTeamSubtitle>
              Team work makes the dream work
            </CoreTeamSubtitle>
          </CoreTeamHeader>

          <CoreTeamGrid>
            {coreTeam.map((member) => (
              <CoreTeamCard key={member.coreTeam.id}>
                <AvatarRing>
                  <AvatarImage
                    src={`${process.env.PUBLIC_URL}${member.coreTeam.image}`}
                    alt={member.coreTeam.name}
                  />
                </AvatarRing>

                <MemberName>{member.coreTeam.name}</MemberName>
                <MemberRole>{member.role}</MemberRole>
              </CoreTeamCard>
            ))}
          </CoreTeamGrid>
          
        </CoreTeamWrapper> */}
        <CoreTeamWrapper>
          <h2 className="section-headings">Core Team</h2>
          <p className="section-sub-text">Team work makes the dream work</p>

          {coreTeamData.map((member, i) => (
            <CoreTeamGrid key={i} className="all-team-mobile-box">
              {member.coreTeam.map((coreTeam) => (
                <CoreTeamCard key={coreTeam.id} data-aos="zoom-in">
                  <AvatarRing>
                    <AvatarImage
                      src={`${process.env.PUBLIC_URL}${coreTeam.image}`}
                      alt={coreTeam.name}
                    />
                  </AvatarRing>

                  <MemberName>{coreTeam.name}</MemberName>
                  <MemberRole>{coreTeam.role}</MemberRole>
                </CoreTeamCard>
              ))}
            </CoreTeamGrid>
          ))}
        </CoreTeamWrapper>
        <CoreTeamWrapper>
          <CoreTeamHeader>
            <h2 className="section-headings">Platform Team</h2>

            {/* <CoreTeamTitle>Platform Team</CoreTeamTitle> */}
            {/* <CoreTeamSubtitle>
              Team work makes the dream work
            </CoreTeamSubtitle> */}
          </CoreTeamHeader>

          {coreTeamData.map((member, i) => (
            <CoreTeamGrid key={i} className="all-team-mobile-box">
              {member.platformTeam.map((platformTeam) => (
                <CoreTeamCard key={platformTeam.id} data-aos="zoom-in">
                  <AvatarRing>
                    <AvatarImage
                      src={`${process.env.PUBLIC_URL}${platformTeam.image}`}
                      alt={platformTeam.name}
                    />
                  </AvatarRing>

                  <MemberName>{platformTeam.name}</MemberName>
                  <MemberRole>{platformTeam.role}</MemberRole>
                </CoreTeamCard>
              ))}
            </CoreTeamGrid>
          ))}
        </CoreTeamWrapper>
        <CoreTeamWrapper>
          <CoreTeamHeader>
            <h2 className="section-headings">Adoption Team</h2>

            {/* <CoreTeamTitle>Adoption Team</CoreTeamTitle> */}
            {/* <CoreTeamSubtitle>
              Team work makes the dream work
            </CoreTeamSubtitle> */}
          </CoreTeamHeader>

          {coreTeamData.map((member, i) => (
            <CoreTeamGrid key={i} className="all-team-mobile-box">
              {member.Adoption.map((Adoption) => (
                <CoreTeamCard key={Adoption.id} data-aos="zoom-in">
                  <AvatarRing>
                    <AvatarImage
                      src={`${process.env.PUBLIC_URL}${Adoption.image}`}
                      alt={Adoption.name}
                    />
                  </AvatarRing>

                  <MemberName>{Adoption.name}</MemberName>
                  <MemberRole>{Adoption.role}</MemberRole>
                </CoreTeamCard>
              ))}
            </CoreTeamGrid>
          ))}
        </CoreTeamWrapper>
        <CoreTeamWrapper>
          <CoreTeamHeader>
            <h2 className="section-headings">Hubs Team</h2>

            {/* <CoreTeamTitle>Hubs Team</CoreTeamTitle> */}
            {/* <CoreTeamSubtitle>
              Team work makes the dream work
            </CoreTeamSubtitle> */}
          </CoreTeamHeader>

          {coreTeamData.map((member, i) => (
            <CoreTeamGrid key={i} className="all-team-mobile-box">
              {member.Hubs.map((Hubs) => (
                <CoreTeamCard key={Hubs.id} data-aos="zoom-in">
                  <AvatarRing>
                    <AvatarImage
                      src={`${process.env.PUBLIC_URL}${Hubs.image}`}
                      alt={Hubs.name}
                    />
                  </AvatarRing>

                  <MemberName>{Hubs.name}</MemberName>
                  <MemberRole>{Hubs.role}</MemberRole>
                </CoreTeamCard>
              ))}
            </CoreTeamGrid>
          ))}
        </CoreTeamWrapper>
      </TeamWrapper>
    </>
  );
}

export default TestimonialsContent;
